import { AlternativeStatusDTO, SpreadsheetColumnToAlternativePropertyMapping } from '@Alternatives/Model';
import { MonthYear } from '@common/types';
import VueCqrs from '@cqrs/vue-component-cqrs';
import Component from 'vue-class-component';
import * as c from '@Alternatives/AlternativesLists/Domain/commands-core';


@Component
export default class AlternativesListsCommands extends VueCqrs
{
	invokeExportAlternativesCommandV1(workspaceId: number, alternativesListId: number, viewDefId: string)
	{
		const cmd = new c.ExportAlternativesCommandV1(workspaceId, alternativesListId, viewDefId);
		this.$command(cmd);
	}

	invokeUpdateAlternativeLabelsCommandV1(workspaceId: number, alternativesListId: number, alternativeLabel: string, alternativesLabel: string)
	{
		const cmd = new c.UpdateAlternativeLabelsCommandV1(workspaceId, alternativesListId, alternativeLabel, alternativesLabel);
		this.$command(cmd);
	}

	invokeUpdateKanbanStatusesCommandV1(workspaceId: number, alternativesListId: number, statuses: AlternativeStatusDTO[])
	{
		const cmd = new c.UpdateKanbanStatusesCommandV1(workspaceId, alternativesListId, statuses);
		this.$command(cmd);
	}

	invokeDeleteKanbanStatusCommandV1(workspaceId: number, projectId: number, alternativesListId: number, statusId: number)
	{
		const cmd = new c.DeleteKanbanStatusCommandV1(workspaceId, projectId, alternativesListId, statusId);
		this.$command(cmd, statusId.toString());
	}


	invokeDeleteAlternativesCommandV1(workspaceId: number, projectId: number, alternativesListId: number, alternativeIds: string[], userId: number)
	{
		const cmd = new c.DeleteAlternativesCommandV1(workspaceId, projectId, alternativesListId, alternativeIds, userId);
		this.$command(cmd);
	}

	invokeUpdateMultipleAlternativesStatusCommandV1(userId: number, workspaceId: number, projectId: number, alternativesListId: number, alternativeIds: string[], statusId: number)
	{
		const cmd = new c.UpdateMultipleAlternativesStatusCommandV1(userId, workspaceId, projectId, alternativesListId, alternativeIds, statusId);
		this.$command(cmd);
	}


	invokeUpdateMultipleAlternativesAttributeValueCommandV1(userId: number, workspaceId: number, projectId: number, alternativesListId: number, alternativeIds: string[], attributeId: number, value: string)
	{
		const cmd = new c.UpdateMultipleAlternativesAttributeValueCommandV1(userId, workspaceId, projectId, alternativesListId, alternativeIds, attributeId, value);
		this.$command(cmd);
	}


	invokeUpdateMultipleAlternativesStartDateCommandV1(workspaceId: number, projectId: number, alternativesListId: number, alternativeIds: string[], startDate: MonthYear | null)
	{
		const cmd = new c.UpdateMultipleAlternativesStartDateCommandV1(workspaceId, projectId, alternativesListId, alternativeIds, startDate);
		this.$command(cmd);
	}

	invokeUpdateMultipleAlternativesCommitmentDateCommandV1(workspaceId: number, projectId: number, alternativesListId: number, alternativeIds: string[], commitmentDate: MonthYear | null)
	{
		const cmd = new c.UpdateMultipleAlternativesCommitmentDateCommandV1(workspaceId, projectId, alternativesListId, alternativeIds, commitmentDate);
		this.$command(cmd);
	}


	invokeRenameAttributesSectionCommandV1(workspaceId: number, projectId: number, alternativesListId: number, oldName: string, newName: string)
	{
		const cmd = new c.RenameAttributesSectionCommandV1(workspaceId, projectId, alternativesListId, oldName, newName);
		this.$command(cmd, newName);
	}

	invokeDownloadEmptyAlternativesSpreadsheetCommandV1(workspaceId: number, projectId: number, alternativesListId: number)
	{
		const cmd = new c.DownloadEmptyAlternativesSpreadsheetCommandV1(workspaceId, projectId, alternativesListId);
		this.$command(cmd);
	}

	invokeImportAlternativesFromSpreadsheetCommandV1(userId: number, workspaceId: number, projectId: number, alternativesListId: number, blobId: string, updateExisting: boolean, columnMappings: SpreadsheetColumnToAlternativePropertyMapping[])
	{
		const cmd = new c.ImportAlternativesFromSpreadsheetCommandV1(userId, workspaceId, projectId, alternativesListId, blobId, updateExisting, columnMappings);
		this.$command(cmd);
	}
}
